export const checkCategory = (phoneNumber, cateDefault) => {
  // console.log(phoneNumber);
  if (phoneNumber) {
    const soduoi2 = phoneNumber.slice(-2);
    const soduoi3 = phoneNumber.slice(-3);
    const soduoi4 = phoneNumber.slice(-4);
    const sogiua3 = phoneNumber.slice(4, 7);
    const sogiua4 = phoneNumber.slice(2, 6);
    var arrCate,
      arrCate2,
      arrCate3,
      arrCate4,
      arrCate5,
      arrTaxi,
      arrTaxiTien,
      arrTuQuy,
      arrNamSinh,
      arrLap,
      arrTamHoaKep,
      arrGanhDao,
      arrMenhSim,
      arrDDMMYY;
    const soduoi5 = phoneNumber.slice(-5);
    const soduoi6 = phoneNumber.slice(-6);
    const sd = [
      soduoi6.slice(0, 1),
      soduoi6.slice(1, 2),
      soduoi6.slice(2, 3),
      soduoi6.slice(3, 4),
      soduoi6.slice(4, 5),
      soduoi6.slice(5, 6),
    ];
    switch (soduoi2) {
      case '39':
      case '79':
        arrCate = 'than-tai,phong-thuy';
        break;
      case '86':
        arrCate = 'phat-loc,phong-thuy';
        break;
      case '68':
        arrCate = 'loc-phat,phong-thuy';
        break;
      case '78':
      case '38':
        arrCate = 'tho-dia,phong-thuy';
        break;
    }
    if (sd[2] !== sd[3] && sd[3] === sd[4] && sd[4] === sd[5]) {
      switch (soduoi3) {
        case '000':
        case '111':
        case '222':
        case '333':
        case '444':
        case '555':
        case '666':
        case '777':
        case '888':
        case '999':
          arrCate2 = 'tam-hoa';
          break;
      }
    }
    switch (soduoi3) {
      case '012':
      case '123':
      case '234':
      case '345':
      case '456':
      case '678':
      case '789':
        arrCate3 = 'sanh-tien,sanh-tien-3';
        break;
    }

    if (sd[1] === sd[2] && sd[2] === sd[3] && sd[3] === sd[4] && sd[4] === sd[5]) {
      switch (soduoi5) {
        case '00000':
        case '11111':
        case '22222':
        case '33333':
        case '44444':
        case '55555':
        case '66666':
        case '77777':
        case '88888':
        case '99999':
          arrTuQuy = 'ngu-quy';
          break;
      }
    } else if (sd[1] !== sd[2] && sd[2] === sd[3] && sd[3] === sd[4] && sd[4] === sd[5]) {
      switch (soduoi4) {
        case '0000':
        case '1111':
        case '2222':
        case '3333':
        case '4444':
        case '5555':
        case '6666':
        case '7777':
        case '8888':
        case '9999':
          arrTuQuy = 'tu-quy';
          break;
      }
    } else if (sd[0] === sd[1] && sd[1] === sd[2] && sd[2] === sd[3] && sd[3] === sd[4] && sd[4] === sd[5]) {
      switch (soduoi6) {
        case '000000':
        case '111111':
        case '222222':
        case '333333':
        case '444444':
        case '555555':
        case '666666':
        case '777777':
        case '888888':
        case '999999':
          arrTuQuy = 'luc-quy';
          break;
      }
    }

    switch (soduoi4) {
      case '0123':
      case '1234':
      case '2345':
      case '3456':
      case '4567':
      case '6789':
        arrCate3 = 'sanh-tien,sanh-tien-4';
        break;
      case '4953':
      case '4078':
      case '7749':
      case '1368':
      case '1102':
      case '2204':
      case '2828':
      case '3131':
      case '4563':
        arrCate3 = 'doc-la,dac-biet';
        break;
    }
    switch (soduoi5) {
      case '01234':
      case '12345':
      case '23456':
      case '34567':
      case '45678':
      case '56789':
        arrCate3 = 'sanh-tien,sanh-tien-5';
        break;
    }

    if (sd[2] + sd[3] === sd[4] + sd[5] || (sd[2] === sd[3] && sd[4] === sd[5])) {
      arrLap = 'lap';
    }
    if (
      (sd[2] !== sd[3] && sd[3] === sd[4] && sd[4] !== sd[5]) ||
      (sd[0] === sd[3] && sd[1] === sd[4] && sd[2] === sd[5])
    ) {
      arrGanhDao = 'ganh-dao';
    }
    if (sd[0] === sd[1] && sd[1] === sd[2] && sd[3] === sd[4] && sd[4] === sd[5] && sd[0] !== sd[5]) {
      arrTamHoaKep = 'tam-hoa-kep';
    }

    if (
      (sd[0] + sd[1] + sd[2] === sd[3] + sd[4] + sd[5]) !==
      (sd[0] === sd[1] && sd[1] === sd[2] && sd[2] === sd[3] && sd[3] === sd[4] && sd[4] === sd[5])
    ) {
      arrTaxi = 'taxi,taxi-3';
    } else if (
      sd[0] + sd[1] === sd[2] + sd[3] &&
      (sd[2] + sd[3] === sd[4] + sd[5]) !==
        (sd[0] === sd[1] && sd[1] === sd[2] && sd[2] === sd[3] && sd[3] === sd[4] && sd[4] === sd[5])
    ) {
      arrTaxi = 'taxi,taxi-2';
    }

    if (
      (sd[0] === sd[1] && sd[1] === sd[2] && sd[2] === sd[3] && sd[3] !== sd[4]) ||
      (sd[1] === sd[2] && sd[2] === sd[3] && sd[3] === sd[4] && sd[4] !== sd[5])
    ) {
      arrCate5 = 'tu-quy-giua';
    }

    if (sd[0] === sd[1] && sd[1] === sd[2] && sd[2] === sd[3] && sd[3] === sd[4] && sd[4] !== sd[5]) {
      arrCate5 = 'ngu-quy-giua';
    }

    if (
      soduoi4.slice(0, 3) === '197' ||
      soduoi4.slice(0, 3) === '198' ||
      soduoi4.slice(0, 3) === '199' ||
      soduoi4.slice(0, 3) === '200' ||
      soduoi4.slice(0, 3) === '201' ||
      soduoi4.slice(0, 3) === '202'
    ) {
      arrNamSinh = 'nam-sinh';
    }
    if (
      parseInt(soduoi6.slice(0, 2)) <= 31 &&
      parseInt(soduoi6.slice(0, 2)) >= 1 &&
      parseInt(soduoi6.slice(2, 4)) <= 12 &&
      parseInt(soduoi6.slice(2, 4)) >= 1 &&
      parseInt(soduoi6.slice(4, 6)) <= 99 &&
      parseInt(soduoi6.slice(4, 6)) >= 70
    ) {
      arrDDMMYY = 'nam-sinh';
    } else if (
      parseInt(soduoi6.slice(0, 2)) <= 31 &&
      parseInt(soduoi6.slice(0, 2)) >= 1 &&
      parseInt(soduoi6.slice(2, 4)) <= 12 &&
      parseInt(soduoi6.slice(2, 4)) >= 1 &&
      parseInt(soduoi6.slice(4, 6)) >= 0 &&
      parseInt(soduoi6.slice(4, 6)) <= 29
    ) {
      arrDDMMYY = 'nam-sinh';
    }
    arrTaxiTien =
      parseInt(sogiua3) === soduoi3 - 1
        ? 'taxi-tien'
        : parseInt(sogiua3) === soduoi3 - 10
        ? 'taxi-tien'
        : parseInt(sogiua3) === soduoi3 - 100
        ? 'taxi-tien'
        : parseInt(sogiua4) === soduoi4 - 1000
        ? 'taxi-tien'
        : parseInt(sogiua4) === soduoi4 - 100
        ? 'taxi-tien'
        : parseInt(sogiua4) === soduoi4 - 10
        ? 'taxi-tien'
        : parseInt(sogiua4) === soduoi4 - 1
        ? 'taxi-tien'
        : '';

    //check menh sim
    const arrSim = [
      arrCate,
      arrCate2,
      arrCate3,
      arrCate4,
      arrCate5,
      arrTaxi,
      arrTaxiTien,
      arrTuQuy,
      arrNamSinh,
      arrLap,
      arrTamHoaKep,
      arrGanhDao,
      cateDefault,
      arrDDMMYY,
    ];
    var filtered = arrSim.filter((value) => value !== undefined && value !== '').join(',');
    // console.log(phoneNumber,filtered)
    return filtered;
  }
};
